
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.107 8.634a7.554 7.554 0 00-.075-.53l1.884-2.827a.5.5 0 00-.574-.751l-2.62.873a5.058 5.058 0 00-.618-.753C17.549 4.092 16.679 3.5 15.5 3.5c-1.223 0-2.127.342-2.773.904-.64.556-.977 1.285-1.15 1.975a6.487 6.487 0 00-.162 1.865c.007.145.018.276.03.39-1.256.267-2.57-.142-3.856-.906-1.418-.842-2.719-2.065-3.735-3.082A.5.5 0 003 4.984c-.127 4.077.713 9.012 4.511 11.514-1.597.864-3.163 1.267-5.073 1.506a.5.5 0 00-.162.943C7.436 21.527 14.12 21.34 17.9 16.3c1.567-2.09 2.092-4.184 2.223-5.759.066-.786.033-1.443-.016-1.907z"}})])
          )
        }
      }
    